"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTreeNodeValidationSchema = exports.validCharacters = void 0;
const react_1 = require("react");
const yup = __importStar(require("yup"));
const product_tree_nodes_1 = require("../../../../../client/product-tree-nodes");
const localization_1 = require("../../../../../../localization");
const store_1 = require("../../../../../../store");
const validCharacters = (value) => /^[a-zA-Z0-9 \-_!@#$%^&*()<>?,/\\|]+$/.test(value);
exports.validCharacters = validCharacters;
const useTreeNodeValidationSchema = () => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const productTreeId = (0, store_1.useProductTreeId)();
    const { getAllProductTreeNodes } = (0, product_tree_nodes_1.useLazyProductTreeNodes)({
        productTreeId,
    });
    const validateNodeNameUniqueness = (0, react_1.useCallback)((value) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!value)
            return true;
        const { data } = yield getAllProductTreeNodes({
            variables: {
                productTreeId,
                filter: {
                    title: {
                        equals: value,
                    },
                },
            },
        });
        return ((_a = data.productTreeNodes) === null || _a === void 0 ? void 0 : _a.totalCount) === 0;
    }), [getAllProductTreeNodes, productTreeId]);
    const schema = (0, react_1.useMemo)(() => yup.object().shape({
        nodeName: yup
            .string()
            .required(t({ key: 'VALIDATION_REQUIRED' }))
            .test('valid-characters', t({ key: 'MUST_CONTAIN_ONLY_LETTERS_NUMBERS_SYMBOLS', values: { name: t({ key: 'NODE_NAME' }) } }), exports.validCharacters)
            .test('unique-nodeName', t({ key: 'VALIDATION_MUST_BE_UNIQUE', values: { name: t({ key: 'NODE_NAME' }) } }), 
        // guard to avoid BE call when previous checks fail
        (value) => __awaiter(void 0, void 0, void 0, function* () {
            if (!value || !(0, exports.validCharacters)(value))
                return true;
            return validateNodeNameUniqueness(value);
        })),
        guidelines: yup
            .string()
            .max(2000, t({ key: 'VALIDATION_NOT_EXCEED_LIMIT_CHARACTERS', values: { limit: '2000' } })),
    }), [t, validateNodeNameUniqueness]);
    return schema;
};
exports.useTreeNodeValidationSchema = useTreeNodeValidationSchema;
